<template>
  <div class="video">
    <aliPlayerHeadTail
      :source="startVideo"
      clientType="pc"
      @videoEnd="videoOver"
    ></aliPlayerHeadTail>
  </div>
</template>
<script>
import aliPlayerHeadTail from "components/aliPlayerHeadTail"
export default {
  components: {
    aliPlayerHeadTail
  },
  methods: {
    videoOver() {
      let conversionData = this.data;
      // if(this.$store.state.inFixedVideo === 'click') {
      //     return this.intoDetail(0 ,0)
      // }
      // let lessonLocation = this.$store.state.lessonLocation
      // if (this.$store.state.lessonLocation) {
      //     let currentChapter = lessonLocation.split("||")[1];
      //     let pIndex = currentChapter.split("-")[0];
      //     let cIndex = currentChapter.split("-")[1];
      //     if(pIndex !== undefined && pIndex !== null && cIndex !== undefined && cIndex !== null) {
      //         this.intoDetail(pIndex ,cIndex)
      //     } else {
      //         this.intoDetail(0 ,0)
      //     }
      // } else {
      //     this.intoDetail(0 ,0)
      // }
      this.intoDetail(0, 0)
    },
    // PC小节路由跳转
    intoDetail(pIndex, cIndex) {
      let conversionData = this.data;
      let cid = conversionData.part_list[pIndex].chapter_list[cIndex].chapter_id;
      let type = parseInt(conversionData.part_list[pIndex].chapter_list[cIndex].chapter_type);
      let quiz = null;
      if (type == '2') {
        quiz = parseInt(conversionData.part_list[pIndex].chapter_list[cIndex].chapter_content.quiz_type)
      }
      // type, quiz, cid
      // // 清除片头片尾的被选中的样式
      this.$store.commit("Zhead", false);
      this.$store.commit("Ztail", false);
      conversionData.part_list[pIndex].chapter_list[cIndex].aliveStatus = true;
      this.$store.commit('currentPartIndex', pIndex)// 保存当前章节节数组下标
      this.$store.commit('currentChapterIndex', cIndex)// 保存当前小节数组下标
      this.$store.commit('cur_data', conversionData.part_list[pIndex].chapter_list[cIndex])// 保存当前小节数组对象
      switch (type) {
        case 1: // 视频
          this.$router.replace({ path: '/pcindex/video', query: { cid: cid } })
          break
        case 2: // 小测验
          this.intoQuiz(quiz, cid)
          break
        case 3: // 文档
          this.$router.replace({ path: '/pcindex/test', query: { cid: cid } })
          break
        case 4: // 图文
          this.$router.replace({ path: '/pcindex/tuwen', query: { cid: cid } })
          break
      }
    },
    // 小测验跳转路由
    intoQuiz(quiz, cid) {
      switch (quiz) {
        case 1: // 单选
          this.$router.replace({ path: '/pcindex/test/single', query: { type: quiz, cid: cid } })
          break
        case 2: // 多选
          this.$router.replace({ path: '/pcindex/test/single', query: { type: quiz, cid: cid } })
          break
        case 3: // 问答
          this.$router.replace({ path: '/pcindex/test/question', query: { type: quiz, cid: cid } })
          break
        case 4: // 拖拽单选
          this.$router.replace({ path: '/pcindex/test/drag', query: { type: quiz, cid: cid } })
          break
        case 5: // 拖拽多选
          this.$router.replace({ path: '/pcindex/test/drag', query: { type: quiz, cid: cid } })
          break
        case 6: // 多行填空
          this.$router.replace({ path: '/pcindex/test/morelineBlank', query: { type: quiz, cid: cid } })
          break
        case 7: // 段落填空
          this.$router.replace({ path: '/pcindex/test/fillblank', query: { type: quiz, cid: cid } })
          break
        case 8: // 判断
          this.$router.replace({ path: '/pcindex/test/judge', query: { type: quiz, cid: cid } })
          break
      }
    },
  }
}
</script>
<style lang="less" scoped>
.video {
  height: 100%;
  padding: 0 40px;
}
</style>
